import styled from 'styled-components'

export const Content = styled.div`
  margin: 1rem 0.5rem;
  max-width: 15rem;
  min-width: 10rem;
`
